import { useState, useCallback } from 'react';
import { downloadJobCostReport, openJobCostReportPdf } from '../api/jobReports';

interface UseJobCostReportReturn {
  downloadPdf: () => Promise<void>;
  downloadExcel: () => Promise<void>;
  openPdf: () => Promise<void>;
  isLoading: boolean;
  error: string | null;
}

export function useJobCostReport(jobId: number): UseJobCostReportReturn {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const downloadPdf = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      await downloadJobCostReport(jobId, 'pdf');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to download report');
    } finally {
      setIsLoading(false);
    }
  }, [jobId]);

  const downloadExcel = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      await downloadJobCostReport(jobId, 'xlsx');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to download report');
    } finally {
      setIsLoading(false);
    }
  }, [jobId]);

  const openPdf = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      await openJobCostReportPdf(jobId);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to open report');
    } finally {
      setIsLoading(false);
    }
  }, [jobId]);

  return { downloadPdf, downloadExcel, openPdf, isLoading, error };
}
